const mediaItems = [
  {
    id: 1,
    title: '《鬼灭之刃：无限城篇》官方PV',
    desc: '炭治郎与伙伴们面对最强上弦之鬼，无限城决战一触即发。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20anime%20scene%20with%20Japanese%20warrior%20silhouette%20against%20burning%20castle%20at%20night%2C%20cherry%20blossom%20petals%20scattered%2C%20intense%20red%20and%20orange%20flames%2C%20cinematic%20lighting%2C%20action%20atmosphere%2C%20high%20contrast%2C%20epic%20composition&width=800&height=500&seq=media-01&orientation=landscape',
    views: '328万',
    duration: '02:15',
  },
  {
    id: 2,
    title: '《凡人修仙传》第五季预告',
    desc: '韩立踏入灵界，仙侠世界的新篇章正式开启。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20cultivation%20scene%20with%20a%20solitary%20figure%20on%20a%20mountain%20peak%2C%20golden%20morning%20mist%2C%20ancient%20temple%20in%20distance%2C%20ethereal%20atmosphere%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20cinematic%20scale&width=800&height=500&seq=media-02&orientation=landscape',
    views: '256万',
    duration: '01:48',
  },
  {
    id: 3,
    title: '《葬送的芙莉莲》第二季先行',
    desc: '芙莉莲的旅程继续，新的伙伴与新的故事在等待。',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20fantasy%20landscape%20with%20a%20small%20group%20of%20travelers%20on%20a%20winding%20road%2C%20cherry%20blossom%20trees%20along%20the%20way%2C%20warm%20afternoon%20sunlight%2C%20gentle%20green%20hills%2C%20soft%20and%20healing%20atmosphere%2C%20pastoral%20anime%20scene&width=800&height=500&seq=media-03&orientation=landscape',
    views: '198万',
    duration: '01:35',
  },
  {
    id: 4,
    title: '《完美世界》特别篇精彩集锦',
    desc: '石昊大战禁区之主的震撼场面，史诗级战斗不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20battle%20scene%20with%20massive%20energy%20clash%20in%20the%20sky%2C%20dramatic%20golden%20and%20coral%20light%20explosions%2C%20ancient%20ruins%20below%2C%20Chinese%20fantasy%20aesthetic%2C%20cinematic%20action%20composition%2C%20powerful%20atmosphere&width=800&height=500&seq=media-04&orientation=landscape',
    views: '187万',
    duration: '03:22',
  },
  {
    id: 5,
    title: '七月新番综合导视',
    desc: '一网打尽七月所有值得追的新番，追番清单速来查收。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20collage%20style%20illustration%20with%20multiple%20mini%20scenes%20arranged%20beautifully%2C%20summer%20theme%20with%20cherry%20blossom%20petals%2C%20vibrant%20warm%20colors%2C%20festive%20atmosphere%2C%20Japanese%20anime%20promotional%20poster%20style%2C%20lively%20composition&width=800&height=500&seq=media-05&orientation=landscape',
    views: '142万',
    duration: '04:10',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            热门PV、预告片和精彩片段，感受动漫的视觉魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl border border-background-200/60 hover:border-accent-200/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-900/20 group-hover:bg-foreground-900/10 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 text-xs px-2 py-0.5 rounded bg-background-950/70 text-background-50 font-medium backdrop-blur-sm whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute bottom-2 left-2 flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-background-950/70 text-background-50 backdrop-blur-sm">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-eye-line text-[10px]"></i>
                  </div>
                  {item.views}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}